//nome = codigo no BD
export const enum EStatusCodigoMinuta {
  'Em Customizacao' = 1,
  'Customizada' = 2,
  'Gerada' = 3,
}
